/* Round twenty-one (2026-08-30), delivery: the shared slider driver
   (snippets/cl-slider-script.liquid, used by cl-product-carousel and
   cl-stories) as a cacheable asset, loaded with defer. One init per
   [data-cl-slider] root (the section root that holds the track and the
   pill), re-run on shopify:section:load; the body is the round-nineteen
   script unchanged, the root lookup by id replaced by the scan below. */
(function () {
  function init(root) {
  if (!root || root.dataset.clSliderReady === '1') return;
  root.dataset.clSliderReady = '1';

  var track = root.querySelector('[data-cl-slider-track]');
  var prev  = root.querySelector('[data-cl-slider-prev]');
  var next  = root.querySelector('[data-cl-slider-next]');
  if (!track || !prev || !next) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var now   = root.querySelector('[data-cl-slider-now]');
  var total = root.querySelector('[data-cl-slider-total]');

  // one step = one card plus the track's column gap
  function step() {
    var slide = track.firstElementChild;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
  }
  function go(dir) {
    track.scrollBy({ left: dir * step(), behavior: reduced ? 'auto' : 'smooth' });
  }
  function sync() {
    var max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
    var s = step();
    var pages = Math.max(1, Math.round(max / s) + 1);
    var at = Math.min(pages, Math.round(track.scrollLeft / s) + 1);
    if (now) now.textContent = at;
    if (total) total.textContent = pages;
  }

  prev.addEventListener('click', function () { go(-1); });
  next.addEventListener('click', function () { go(1); });
  track.addEventListener('scroll', sync, { passive: true });

  // Mouse drag. Touch already scrolls natively; a mouse gets the same
  // by moving scrollLeft under the pointer, with snapping suspended
  // until release so the track does not fight the hand. A drag of
  // more than a few pixels swallows the click on the card under it.
  var drag = null;
  track.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    drag = { x: e.clientX, left: track.scrollLeft, moved: false, lastX: e.clientX, lastT: e.timeStamp, v: 0 };
    track.classList.add('is-dragging');
  });
  track.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (Math.abs(dx) > 4) { drag.moved = true; track.setPointerCapture(e.pointerId); }
    // velocity in px/ms, smoothed, for the flick on release
    var dt = Math.max(1, e.timeStamp - drag.lastT);
    drag.v = drag.v * .6 + ((e.clientX - drag.lastX) / dt) * .4;
    drag.lastX = e.clientX; drag.lastT = e.timeStamp;
    track.scrollLeft = drag.left - dx;
  });
  // Snapping stays off until the settle scroll has finished: putting it
  // back while the track is still moving is what made a release jump.
  var settleTimer = null;
  function release(e) {
    if (!drag) return;
    var moved = drag.moved, v = drag.v, from = drag.left;
    drag = null;
    if (!moved) { track.classList.remove('is-dragging'); return; }
    track.dataset.clDragged = String(Date.now());
    var s = step();
    // a flick carries one card in its direction; a slow drag settles
    // on the nearest card. Either way the target is a card's left
    // edge on the container's left edge.
    var target;
    if (Math.abs(v) > .35) {
      var startIdx = Math.round(from / s);
      var idx = v < 0 ? Math.floor(track.scrollLeft / s) + 1 : Math.ceil(track.scrollLeft / s) - 1;
      if (v < 0 && idx <= startIdx) idx = startIdx + 1;
      if (v > 0 && idx >= startIdx) idx = startIdx - 1;
      target = idx * s;
    } else {
      target = Math.round(track.scrollLeft / s) * s;
    }
    target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, target));
    clearTimeout(settleTimer);
    var done = function () { clearTimeout(settleTimer); track.classList.remove('is-dragging'); track.removeEventListener('scrollend', done); };
    track.addEventListener('scrollend', done);
    settleTimer = setTimeout(done, 700);
    if (Math.abs(target - track.scrollLeft) < 1) { done(); return; }
    track.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
  }
  track.addEventListener('pointerup', release);
  track.addEventListener('pointercancel', release);
  track.addEventListener('click', function (e) {
    var t = +track.dataset.clDragged || 0;
    if (t && Date.now() - t < 400) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  track.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft')  { e.preventDefault(); go(-1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
  });
  window.addEventListener('resize', sync);
  sync();
  }
  function scan(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-cl-slider]')) init(scope);
    if (scope.querySelectorAll) Array.prototype.forEach.call(scope.querySelectorAll('[data-cl-slider]'), init);
  }
  /* The tag is emitted once per instance and the theme editor re-inserts it
     with a re-rendered section, so a second run only scans for new roots. */
  if (window.clSliderScan) { window.clSliderScan(document); return; }
  window.clSliderScan = scan;
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
